import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface Filter {
  label: string;
  value: string;
}

@Component({
  selector: 'app-filters',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
  @Input() filters: Filter[];
  @Input() selected: string;
  @Output() change: EventEmitter<string> = new EventEmitter();
  constructor() {}

  ngOnInit() {}
}
